/* ===== HEADER JS ===== */
(function() {
  'use strict';

  var header = document.getElementById('esm-header');
  var mobileMenu = document.getElementById('esm-mobile-menu');
  var menuToggles = document.querySelectorAll('[data-menu-toggle]');
  var menuClose = document.querySelectorAll('[data-menu-close]');

  // Scroll detection
  var scrollThreshold = 40;
  function handleScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('esm-header--scrolled');
    } else {
      header.classList.remove('esm-header--scrolled');
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // Mobile menu toggle
  function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // Close sub-menus
    var sub = document.querySelector('[data-mobile-catalogue-sub]');
    var chevron = document.querySelector('[data-mobile-catalogue-toggle]');
    if (sub) sub.classList.remove('is-open');
    if (chevron) chevron.classList.remove('is-open');
  }

  menuToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (mobileMenu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  });

  menuClose.forEach(function(btn) {
    btn.addEventListener('click', closeMenu);
  });

  // Close menu on link click
  mobileMenu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });

  // Mobile catalogue sub-menu
  var mobileCatalogueToggle = document.querySelector('[data-mobile-catalogue-toggle]');
  var mobileCatalogueSub = document.querySelector('[data-mobile-catalogue-sub]');

  if (mobileCatalogueToggle && mobileCatalogueSub) {
    mobileCatalogueToggle.addEventListener('click', function() {
      mobileCatalogueSub.classList.toggle('is-open');
      mobileCatalogueToggle.classList.toggle('is-open');
    });
  }

  // Desktop catalogue dropdown
  var dropdownWrap = document.querySelector('[data-catalogue-dropdown]');
  var catalogueToggle = document.querySelector('[data-catalogue-toggle]');
  var catalogueMenu = document.querySelector('[data-catalogue-menu]');

  if (dropdownWrap && catalogueToggle && catalogueMenu) {
    var closeTimeout = null;

    function openDropdown() {
      if (closeTimeout) clearTimeout(closeTimeout);
      catalogueMenu.classList.add('is-open');
      catalogueToggle.classList.add('is-open');
    }

    function closeDropdown() {
      closeTimeout = setTimeout(function() {
        catalogueMenu.classList.remove('is-open');
        catalogueToggle.classList.remove('is-open');
      }, 200);
    }

    catalogueToggle.addEventListener('click', function() {
      if (catalogueMenu.classList.contains('is-open')) {
        catalogueMenu.classList.remove('is-open');
        catalogueToggle.classList.remove('is-open');
      } else {
        openDropdown();
      }
    });

    catalogueToggle.addEventListener('mouseenter', openDropdown);
    dropdownWrap.addEventListener('mouseleave', closeDropdown);
    catalogueMenu.addEventListener('mouseenter', function() {
      if (closeTimeout) clearTimeout(closeTimeout);
    });
  }
})();
